import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function PublicRoute({ children }) {
  const token = Cookies.get("test_engine_token");
  const project = Cookies.get("test_engine_project");
  const rawCandidateInfo = sessionStorage.getItem("candidate_details");

  if (token && project && rawCandidateInfo) {
    return <Navigate to={`/${project}/home`} replace />;
  }

  return children;
}
